import axios from "axios";
import { IP } from "../index";
// 查询
export async function selectApi(data) {
  var resp = await axios.post(`${IP}/admin/tieba/comment/select`, {
    ...data,
  });
  return resp.data;
}

// 删除
export async function deleteApi(data) {
  var resp = await axios.post(`${IP}/admin/tieba/comment/delete`, {
    ...data,
  });
  return resp.data;
}

// 新增或修改
export async function addApi(data) {
  var resp = await axios.post(`${IP}/admin/tieba/comment/add`, {
    ...data,
  });
  return resp.data;
}

